import React from 'react';
import Profile from "../Profile";
import IconName from "../../../svgLogo/SvgLogo";

const EmailProfile = () => {
    return (
        <div className="email-profile-wrapper">
            <Profile/>
            <div className="container email-container">
                <div className="input-email-text xmb-8 position-relative">
                    <input type="text" className="input-text" placeholder="پیغام خود را وارد کنید…"/>
                    <div className="submit-email position-absolute"><IconName name="arrow_forward" className="icon"/>
                    </div>
                </div>
                <div className="text-email xp-4">
                    <p className="text">
                        من الان سه ماهه سامسونگ داشتم عوض کردم اینو خریدم یعنی تا امروز هرروز یدونه امکانات جدیدشو
                        میبینم و کیفیت و سرعتش حرف نداره … گیم بوتر داره که رم رو از هر لحاظ به نحو صحیح عمل میکنه ـ.
                        کیفیت گرافیکی عالی … دوربیناش فوق العاده خوب … لمس و تاچ و نرم افزاری که حرف نداره … هر هفته هم
                        یه نوع آپدیت میاد برات که بروز میکنه و امکانات اضافه میشه یعنی انگا داری هر هفته یه گوشی مدل
                        بالاشو میخری
                    </p>
                </div>
                <div
                    className="info-email d-flex justify-content-between align-items-center flex-wrap">
                    <div className="question-email">
                        <span className="question xmt-4">آیا این نظر برایتان مفید بود؟</span>
                        <span className="yes persian-number xmt-4">بله (191)</span>
                        <span className="no persian-number xmt-4">خیر (29)</span>
                    </div>
                    <div className="response">
                        <div className="button xmt-4">پاسخ</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailProfile;
